import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import { Message } from '@fasstech/middle-design-system';
import getErrorMessage from '@@viewCommonComponents/controlled/helpers/getErrorMessage.js';
import { isRequiredSelect } from '@@viewHelpers/validations';
import { isNotNilOrEmpty } from '@@serverHelpers/index.mjs';
import { ControlledInput, ControlledSelect } from '@@viewCommonComponents/controlled/index.js';
import { propOr } from 'ramda';

const ControlledPhoneInput = ({
  rules = {},
  form,
  name,
  internationalCodeName = 'internationalCode',
  isInternational = false,
  isMobile = true,
  phoneNumberName = 'number',
  options = [],
  label,
  containerClassName = '',
  messageClassName = '',
  isDisplayed = true,
  disabled = false,
  ...extraProps
}) => {
  if (!isDisplayed) {
    return null;
  }
  const methods = useFormContext();

  const phoneNumber = form.watch(`${name}.${phoneNumberName}`);
  const testId = propOr('', 'data-testid', extraProps);

  useEffect(() => {
    methods.setValue(`${name}.isMobile`, isMobile);
  }, []);

  return (
    <div className={`w-full md:w-[100%]! ${containerClassName}`}>
      <div className="sm:grid sm:grid-cols-3 gap-x-2.5">
        {isInternational && (
          <div className="col-span-1 mb-2 sm:mb-0">
            <ControlledSelect
              name={`${name}.${internationalCodeName}`}
              label={'Indicatif'}
              form={form}
              options={options}
              withIndicator={true}
              rules={isRequiredSelect(options, isNotNilOrEmpty(phoneNumber))}
              disabled={disabled}
              data-testid={`${testId}-InternationalCode`}
              {...extraProps.InternationalCodeSelectProps}
            />

          </div>
        )}
        <div className={isInternational ? 'col-span-2' : 'col-span-4'}>
          <ControlledInput
            name={`${name}.${phoneNumberName}`}
            label={label}
            form={form}
            rules={rules}
            disabled={disabled}
            data-testid={`${testId}-PhoneNumber`}
          />
        </div>
      </div>
      <Message
        className={messageClassName}
        variant="error"
        label={
          getErrorMessage(form.formState.errors, `${name}.${phoneNumberName}`)
        }
      />
    </div>
  );
};

export default ControlledPhoneInput;
